import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";

// Typage des props du composant
interface U31414MasterChildLotChainDlgProps {
  handleDelete: U2000DeleteHandlersReturn;
  t: TFunction;
  NS: string;
}

function U31414MasterChildLotChainDeleteDlg({ handleDelete, t, NS }: U31414MasterChildLotChainDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={handleDelete.isDialogDeleteOpen} onClose={handleDelete.handleDeleteCloseDlg} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("user.msgDeleteUserRole", {
          count: handleDelete.selectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handleDelete.selectedRows().map((row, index, array) => (
          <span key={row.lotDetail.lot} className="inline-block text-gray-800">
            {`${row.lotDetail.lot}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U31414MasterChildLotChainDeleteDlg;
